<template>
  <v-row justify="center">
    <v-dialog v-model="dialogLocal" max-width="350px">
        <v-card>
            <v-form ref="loginForm" action="#" @submit.prevent="validateBeforeSubmit" lazy-validation>
            <v-card-title class="justify-space-between" :style="{'background-color': '#FBCE07'}" style="color: white; padding-top: 5px; padding-bottom: 5px">
            Verify Mobile
            <v-btn text @click="$emit('closed', false)" fab depressed small><v-icon small color="black">fas fa-times</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" class="text-center">
                        <span class="text-body-2">Enter Activation Code sent to {{content}}</span>
                            <v-text-field required :rules="user.rule" v-model="user.tac" light="light" prepend-icon="fa fa-phone-square-alt" label="" type="text" hint="Activation Code will be expired in 15min." persistent-hint></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn type="submit" small color="primary" :loading="loading" :disabled="loading">
                        Verify
                        <template v-slot:loader>
                            <span>Loading...</span>
                        </template>
                </v-btn>
            <v-btn small dark color="red darken-1" @click="$emit('closed', false)">Close</v-btn>
            </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
    <alertbox :dialog="ex.modal" @closed="onClosed" :content="ex.content"></alertbox>
    <v-snackbar
        v-model="toaster"
        :color="toasterColor"
        top
        >
        {{ toastertxt }}
    </v-snackbar>
  </v-row>
</template>

<script>
import alertbox from './Notification';
import timer from '../../assets/js/sleeper';

  export default {
    props: ['dialog', 'content'],

    data() {
        return {
            dialogLocal: false,
            user: {
                name: '',
                rule: []
            },
            loading: false,
            ex: {
                modal: false,
                content: {
                    headline: '',
                    icon: '',
                    chipColor: '',
                    iconColor: '',
                    maintext: '',
                    smalltext: ''
                }
            },
            toaster: false,
            toastertxt: '',
            toasterColor: 'red',
        }
    },

    components: {
        alertbox
    },

    watch: {
        dialog: {
        handler: function(value) {
            this.modalHandler();
        },
        },

        dialogLocal: {
        handler: function(value) {
            if (value == false)
                this.user.tac = '';
                this.user.rule = [];

            this.modalCloseHandler();
        },
        },

        'ex.modal': {
        handler: function(value) {
            if (value == false){
                location.reload();
            }
        },
        },
    },

    methods: {
        async userReset(){
            this.loading = true

            try{
                await timer.sleep(800);
                let response = await this.$store.dispatch("linkMobileToEmailCustomerVerify", {
                                    mobile: this.content,
                                    tac: this.user.tac,
                                    })
                this.$emit('closed', false);
                if (response.data.code === 'AP000')
                {
                    //localStorage.setItem('tempitem', 'registered');
                    this.loading = false;
                    this.ex.modal = true;
                    this.ex.content.headline = 'Linked!';
                    this.ex.content.icon = 'fa fa-check';
                    this.ex.content.chipColor = '#a0e8af';
                    this.ex.content.iconColor = 'green';
                    this.ex.content.maintext = 'Your mobile number is now linked to this account';
                    this.ex.content.smalltext = 'You may now close this screen.';
                }

                else if (response.data.code === 'AP002')
                {
                    this.loading = false;
                    this.toaster = true;
                    this.toastertxt = "Invalid TAC";
                }

                else if (response.data.code === 'RD002')
                {
                    this.loading = false;
                    this.toaster = true;
                    this.toastertxt = "This number may already be registered to another account";
                }

                else
                {
                    this.loading = false;
                    this.toaster = true;
                    this.toastertxt = "Something went wrong";
                }
            }

            catch(err){
                this.loading = false;
                this.toaster = true;
                this.toastertxt = "API Error";
            }
        },

        modalHandler(){
            this.dialogLocal = !this.dialogLocal;
        },

        modalCloseHandler(){
            if (this.dialogLocal == false)
            this.$emit('closed', false);
        },

        validateBeforeSubmit() {
            this.user.rule = [];

            this.user.rule = [
                v => !!v || 'TAC is required',
                v => !Number.isNaN(Number(v)) || 'Please enter TAC number'
            ];

            //must set this in order to use 'this' as 'self' inside settimeout etc..
            let self = this;

            setTimeout(function () {
             if (self.$refs.loginForm.validate()) {
                    self.userReset();
                }
            });
        },

        onClosed(value){
            if (value == false){
                this.autoRefresh = 1;
                this.ex.modal = value;
            }
        },
    }
  }
</script>